const axios = require('axios')
const api = process.env.VUE_APP_API_ROOT

const getFoods = async function() {
    const response = await axios.get(`${api}/foods`)
    return response
}

const addFood = async function(food) {
    const response = await axios.post(`${api}/foods`, food)
    return response
}

export {
    getFoods,
    addFood
}